import React from "react";

const TemarioProgramaInmunizaciones = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Conceptos generales y poblaciones de riesgo"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Interpretar los conceptos del PAI."}</span></li>
                <li><span className="fw-light">{"Identificar poblaciones de riesgo y sus necesidades."}</span></li>
                <li><span className="fw-light">{"PAI significado (dónde y cuándo nace)."}</span></li>
                <li><span className="fw-light">{"Objetivos y metas del programa. Población objetivo."}</span></li>
                <li><span className="fw-light">{"Poblaciones de riesgo. Menores de un año, mujeres embarazadas, mujeres en edad fértil, trabajadores de la salud."}</span></li>
            </ul>
            <br /><br />
            <b>{"Conceptos, técnicas y vías de administración"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Conocer las diferentes formas de inmunización."}</span></li>
                <li><span className="fw-light">{"Identificar y describir las diferentes técnicas y vías de administración."}</span></li>
                <li><span className="fw-light">{"Conceptos generales."}</span></li>
                <li><span className="fw-light">{"Toxoide. Inmunoglobulina. Antitoxina."}</span></li>
                <li><span className="fw-light">{"Vacunación e inmunización."}</span></li>
                <li><span className="fw-light">{"Formas de inmunización."}</span></li>
                <li><span className="fw-light">{"Vías de administración."}</span></li>
            </ul>
            <br /><br />
            <b>{"Enfermedades del PAI: descripción, transmisión y epidemiología"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Describir las principales enfermedades del programa."}</span></li>
                <li><span className="fw-light">{"Reconocer los mecanismos de transmisión y producción de la enfermedad."}</span></li>
                <li><span className="fw-light">{"Descripción de cada una, vías de transmisión, características epidemiológicas."}</span></li>
            </ul>
            <br /><br />
            <b>{"Vacunas: características, esquemas y recomendaciones"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Describir las características de cada una de las vacunas."}</span></li>
                <li><span className="fw-light">{"Señalar las edades de vacunación."}</span></li>
                <li><span className="fw-light">{"Nombrar el número de dosis de cada vacuna."}</span></li>
                <li><span className="fw-light">{"Conocer las contraindicaciones y reacciones desfavorables."}</span></li>
                <li><span className="fw-light">{"Analizar la eficacia de las vacunas."}</span></li>
                <li><span className="fw-light">{"BCG. HB. VOP-VIP."}</span></li>
                <li><span className="fw-light">{"Quíntuple DPT-Hib-HB."}</span></li>
                <li><span className="fw-light">{"DTPa-Hib-IPV."}</span></li>
                <li><span className="fw-light">{"DTPa-Hib-IPV-HB."}</span></li>
                <li><span className="fw-light">{"Neumococo conjugada."}</span></li>
                <li><span className="fw-light">{"Rotavirus."}</span></li>
                <li><span className="fw-light">{"Antigripal. Meningococo. Triple Viral. Hepatitis A."}</span></li>
                <li><span className="fw-light">{"Varicela. Fiebre amarilla."}</span></li>
            </ul>
            <br /><br />
            <b>{"Conservación de vacunas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Identificar los problemas que afectan la cadena de frío."}</span></li>
                <li><span className="fw-light">{"Describir la importancia de la temperatura en la conservación de las vacunas en sus diferentes niveles."}</span></li>
                <li><span className="fw-light">{"Reconocer las diferentes temperaturas que requiere cada una de las vacunas del programa."}</span></li>
                <li><span className="fw-light">{"Conceptos generales."}</span></li>
                <li><span className="fw-light">{"Control de temperatura."}</span></li>
                <li><span className="fw-light">{"Almacenamiento y transporte."}</span></li>
            </ul>
            <br /><br />
            <b>{"Principios de administración y gestión en salud"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Principios generales de administración y su aplicación en organizaciones de salud."}</span></li>
            </ul>
        </div>
    );
};

export default TemarioProgramaInmunizaciones;
